// src/components/Skills/CombinedSkills.jsx
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { getCategorizedSkillsFromRepos } from '../../data/githubData';
import { 
  FaCode, FaTerminal, FaLaptopCode, FaDatabase, FaTools, FaGithub 
} from 'react-icons/fa';
import SkillGroup from '../shared/SkillGroup';
import './CombinedSkills.css';

const getCategoryIcon = (label) => {
  const iconMap = {
    'Programming Languages': <FaCode />,
    'Frameworks': <FaTerminal />,
    'Databases': <FaDatabase />,
    'Tools': <FaTools />,
    'IDE': <FaLaptopCode />
  };
  return iconMap[label] || <FaGithub />;
};

const CombinedSkills = ({ username = 'PasinduPerera10' }) => {
  const [githubSkills, setGithubSkills] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGithubSkills = async () => {
      try {
        const data = await getCategorizedSkillsFromRepos(username, 12);
        if (data.categories.length === 0) {
          setError('No skills detected in your GitHub repositories');
        } else {
          setGithubSkills(data);
        }
      } catch (err) {
        setError('Failed to fetch skills from GitHub');
      } finally {
        setLoading(false);
      }
    };

    fetchGithubSkills();
  }, [username]);

  if (loading) {
    return (
      <div className="combined-skills-loading">
        <div className="combined-skills-loading__spinner" />
        <p>Loading skills...</p>
      </div>
    );
  }

  if (error) {
    return (
      <motion.section 
        className="combined-skills" 
        id="skills"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <div className="combined-skills__error">
          <FaGithub className="combined-skills__error-icon" />
          <p>{error}</p>
        </div>
      </motion.section>
    );
  }

  const categories = githubSkills.categories.map(cat => ({
    ...cat,
    icon: getCategoryIcon(cat.label)
  }));

  return (
    <motion.section 
      className="combined-skills" 
      id="skills"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <SkillGroup 
        id="github-skills" 
        title="My Skills" 
        categories={categories} 
      />
    </motion.section>
  );
};

export default CombinedSkills;